
import createIcon from "./createIcon";

export const FlameIcon = createIcon('Flame', (props) => {
  return (
    <svg {...props}>
      <g>
        <path d="M5.25 15.2C4.3 13.2 4.8 12.04 5.55 11C6.35 9.79 6.55 8.65 6.55 8.65C6.55 8.65 7.2 9.44 6.95 10.75C8.05 9.5 8.25 7.5 8.1 6.75C10.6 8.5 11.7 12.35 10.25 15.15C17.95 10.75 12.15 4.19 11.15 3.5C11.5 4.25 11.55 5.5 10.85 6.09C9.7 1.69 6.85 0.84 6.85 0.84C7.2 3.09 5.65 5.54 4.15 7.4C4.1 6.5 4.05 5.9 3.55 5C3.45 6.65 2.2 7.94 1.85 9.59C1.4 11.85 2.2 13.45 5.25 15.2Z" fill={props.color} fillOpacity="1" fillRule="nonzero" />
      </g>
    </svg >
  )
});
